import React from 'react';
import Section from '../Section';
import home3 from "../Images/home3.png";
import funfact from "../Images/funfact.jpeg";
import banner_bg from "../Images/banner_bg.svg";
import TeamSection from '../Section/TeamSection';
import { pageTitle } from '../../helpers/PageTitle';
import FunFactSection from '../Section/FunFactSection';
import a23 from "../Images/a23.jpg";
import a2 from "../Images/a2.png";
import AwardSectionStyle2 from '../Section/AwardSection/AwardSectionStyle2';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import FeaturesSectionStyle4 from '../Section/FeaturesSection/FeaturesSectionStyle4';
import DepartmentSectionStyle5 from '../Section/DepartmentSection/DepartmentSectionStyle5';
import BannerSectionStyle2 from '../Section/BannerSection/BannerSectionStyle2';
import AppointmentSectionStyle2 from '../Section/AppointmentSection/AppointmentSectionStyle2';
import FeaturesSectionStyle3 from '../Section/FeaturesSection/FeaturesSectionStyle3';

const awardData = [
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: 'Healthcare Domain Consultation',
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: 'Implementation of ERP'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: 'Implementation of Healthcare Solutions',
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: 'Migration Services',
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: 'Customer Support Services',
  },
];

const awardData1 = [
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: '🔹 Healthcare-First Design',
    subTitle: 'Every workflow in Medna is designed around how clinics and hospitals actually function—front desk, nursing, doctors, billing teams, and administrators.',
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
    title: '🔹 UAE Regulatory Readiness',
    subTitle:'Medna is built with UAE healthcare regulations in mind, including interoperability expectations, insurance workflows, and data residency requirements.'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
   title: '🔹 Security & Trust',
    subTitle:'Patient data is treated as critical infrastructure. Medna follows ISO 27001-aligned security principles, role-based access control, audit trails, and secure deployment models, including on-premise installations.'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/icons/award.svg',
   title: '🔹 Practical Implementation',
    subTitle:'We understand that implementation is as important as software. Medna is designed to be deployed, adopted, and supported smoothly within healthcare facilities.'
  },
];

const featureListData = [
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_6.png',
    title: 'Vision',
    subTitle:
      'To be UAE’s most trusted healthcare ERP — enabling every hospital and clinic to deliver data- driven, efficient, and patient - centered care.'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_7.png',
    title: 'Mission',
    subTitle:
      'To simplify healthcare operations through intelligent, affordable, and scalable ERP systems that empower providers, improve efficiency, and enhance patient outcomes.',
  },
];

const funFactData = [
  { number: '15+', title: 'Years of experience' },
  { number: '1.6 Cr', title: 'Patient Registration' },
  { number: '700000+', title: 'Transactions per day.' },
  { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
  { number: '5+', title: 'Countries Customers' },
];

const galleryData = [
  { imgUrl: '/images/about/portfolio_2_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_3_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_1_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_4_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_5_lg.jpeg' },
];

const teamData = [
  {
    imgUrl: 'images/about/doctor_1.png',
    name: 'Chaitanya Kumar',
    designation: 'Solution Architect',
    description:
      'Chaitanya is a solution architect with over 10 years of experience in the healthcare industry. He is a expert in building scalable and efficient solutions for healthcare organizations.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
  },
  {
    imgUrl: 'images/about/doctor_2.png',
    name: 'Vishwanath Mara',
    designation: 'Solution Architect',
    description:
      'Vishwanath is a solution architect with over 10 years of experience in the healthcare industry. He is a expert in building scalable and efficient solutions for healthcare organizations.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
  },
  {
    imgUrl: 'images/about/doctor_3.png',
    name: 'Chetan Gadad',
    designation: 'Solution Architect',
    description:
      'Chetan is a solution architect with over 10 years of experience in the healthcare industry. He is a expert in building scalable and efficient solutions for healthcare organizations.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
  },
];

const departmentData = [
  {
    title: 'Innovation that Matters',
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/innovation.png',
  },
  {
    title: 'Trust and Transparency ',
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/trusticon.png',
  },
  {
    title: 'Data Integrity',
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/dataintegrity.png',
  },
  {
    title: 'Customer-Centric Service',
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/customer.png',
  },
];

const featureData = [
  {
    title: 'NABIDH',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/abdm.png',
  },
  {
    title: 'DHA',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/nabh.png',
  },
  {
    title: 'Insurance Claim APIs',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/insurance.png',
  },
  {
    title: 'LIS & Diagnostic machines',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/diagnostic.png',
  },
  {
    title: 'Pharmacy Billing Syatems',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/pharmacy.png',
  },
];

const featureData2 = [
  {
    title: 'AES-256 Encryption',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/aes256.png',
  },
  {
    title: 'ISO 27001 Hosting in UAE',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/iso.png',
  },
  {
    title: 'Daily Backups',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/backup.png',
  },
  {
    title: 'Role Based Access & Audit Logs',
    iconUrl: process.env.PUBLIC_URL + '/images/departments/role.png',
  },
];


export default function About() {
  pageTitle('About');
  return (
    <>
      <BannerSectionStyle3
        bgUrl={banner_bg}
        imgUrl={home3}
        title="  Empowering Emirati Healthcare Through Technology "
        subTitle="Medna Data Systems is a healthcare technology company
delivering enterprise-grade ERP systems that unify hospitals, clinics, and diagnostics into
one connected ecosystem."
      />
      <Section topMd={175} topLg={125} topXl={85}>
        <FunFactSection
          bgUrl={funfact}
          data={funFactData}
        />
      </Section>
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <Section topMd={200} topLg={150} topXl={110}>
          <FeaturesSectionStyle4
            sectionTitle="Vision & Mission"
            data={featureListData}
            useVisionMissionDesign={true}
          />
        </Section >
        <Section
          topMd={190}
          topLg={145}
          topXl={105}
          bottomMd={200}
          bottomLg={150}
          bottomXl={110}
        >
          <AwardSectionStyle2 topMd={200} topLg={150} topXl={110}
            sectionTitle="Provides Our Best Services"
            sectionTitleUp="Medna Data Systems"
            sectionSubTitle="We have been recognized for our commitment to <br />excellence in healthcare."
            data={awardData}
          />
        </Section>
      </Section>
      <Section
        topMd={30}
        topLg={25}
        topXl={20}
        bottomMd={30}
        bottomLg={25}
        bottomXl={20}
      >
        <DepartmentSectionStyle5
          sectionTitle="Core Values"
          sectionTitleUp="Medna Data Systems"
          data={departmentData}
        />
      </Section>
      <Section
        topMd={100}
        topLg={75}
        topXl={60}
        bottomMd={100}
        bottomLg={75}
        bottomXl={60}
      >
        <FeaturesSectionStyle3
          sectionTitle="Integration & Compliance"
          data={featureData}
        />
      </Section>
      <Section
          topMd={190}
          topLg={145}
          topXl={105}
          bottomMd={200}
          bottomLg={150}
          bottomXl={110}
        >
          <AwardSectionStyle2 topMd={200} topLg={150} topXl={110}
            sectionTitle="What We Stand For"
            sectionTitleUp="Medna Data Systems"
            sectionSubTitle="We have been recognized for our commitment to <br />excellence in healthcare."
            data={awardData1}
          />
        </Section>
        <Section topMd={170} topLg={120} topXl={80} >
        <FeaturesSectionStyle3
          sectionTitle="Security"
          data={featureData2}
        />
      </Section>
      {/* <Section topMd={170} topLg={120} topXl={80}>
        <GallerySection
          sectionTitle="Flow Chart showing details of Hospital , Labs, Pharmacy and Clinic workflow on unified platform"
          sectionTitleUp="HAVE A LOOK AT"
          data={galleryData}
          imageUrl={process.env.PUBLIC_URL + '/images/flowchart.png'}
        />
      </Section> */}
      
      {/* <Section
        topMd={100}
        topLg={75}
        topXl={60}
        bottomMd={100}
        bottomLg={75}
        bottomXl={60}
      >
        <TeamSection
          sectionTitle="Expert Domain Specialist"
          sectionTitleUp="MEET OUR"
          data={teamData}
        />
      </Section> */}
      <Section >
        <BannerSectionStyle2
          bgUrl={a23}
          title="Don’t Let Your Hospital <br />Take a Backseat!"
          subTitle="Schedule an demo with one of our experienced <br />professionals today!"
        />
      </Section>
      <Section>
        <AppointmentSectionStyle2
          bgUrl="/images/home_2/appointment_bg.svg"
          imgUrl={a2}
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
        />
      </Section>
    </>
  );
}
